import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import { TextComponentType } from './text.types';

import { Skeleton, SkeletonProps } from '../skeleton';

export interface TextProps {
  className?: string;
  as?: TextComponentType;
  emptyValue?: React.ReactNode;
  isEmpty?: boolean;
  loading?: boolean;
  SkeletonProps?: SkeletonProps;
  title?: string;
}

/**
 * Text element enhanced with more options (e.g. loading, empty fallback)
 */
export function Text({
  children,
  className,
  as,
  emptyValue = '-',
  isEmpty = false,
  loading = false,
  SkeletonProps,
  title
}: PropsWithChildren<TextProps>) {
  const Component: TextComponentType = as || 'span';

  return (
    <Component className={classNames('overflow-hidden text-ellipsis', className)} title={title}>
      {loading && <Skeleton variant="text" {...SkeletonProps} />}
      {!loading && (isEmpty ? emptyValue : children)}
    </Component>
  );
}

export default Text;
